import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import { toast } from "sonner";

const fmt = (v) => {
  if (!v) return "—";
  const parts = [];
  if (v.status) parts.push(v.status);
  if (v.role) parts.push(v.role);
  if (v.email) parts.push(v.email);
  if (v.active !== undefined) parts.push(v.active ? "ATTIVO" : "NON ATTIVO");
  if (v.last_name) parts.push(`${v.last_name} ${v.first_name || ""}`);
  if (v.inserted !== undefined) parts.push(`importati: ${v.inserted}`);
  return parts.length ? parts.join(" · ") : JSON.stringify(v).slice(0, 90);
};

export default function AuditLog() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/audit-logs", { params: { limit: 300 } })
      .then((r) => setRows(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);

  return (
    <div data-testid="audit-page" className="space-y-3">
      <div>
        <h1 className="text-2xl sm:text-3xl font-head font-bold tracking-tight">Registro Modifiche</h1>
        <p className="text-sm text-muted-foreground mt-1">Ultime {rows.length} operazioni tracciate</p>
      </div>
      <div className="rounded-sm border border-border bg-card overflow-x-auto scroll-thin">
        <table className="w-full text-sm" data-testid="audit-table">
          <thead className="bg-secondary">
            <tr>{["Data/Ora", "Utente", "Azione", "Entità", "Riferimento", "Valore precedente", "Nuovo valore"].map((h) => (
              <th key={h} className="px-3 py-2 text-left text-[11px] font-semibold uppercase tracking-wider text-muted-foreground whitespace-nowrap">{h}</th>
            ))}</tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.id} className="border-t border-border hover:bg-secondary/40">
                <td className="px-3 py-1.5 tabular-nums text-xs whitespace-nowrap">
                  {new Date(r.created_at).toLocaleString("it-IT")}
                </td>
                <td className="px-3 py-1.5 text-xs">{r.user_email}</td>
                <td className="px-3 py-1.5 text-xs font-semibold">{r.action}</td>
                <td className="px-3 py-1.5 text-xs">{r.entity}</td>
                <td className="px-3 py-1.5 text-xs text-muted-foreground">{r.entity_id}</td>
                <td className="px-3 py-1.5 text-xs text-muted-foreground">{fmt(r.before)}</td>
                <td className="px-3 py-1.5 text-xs">{fmt(r.after)}</td>
              </tr>
            ))}
            {rows.length === 0 && <tr><td colSpan={7} className="px-3 py-8 text-center text-muted-foreground">Nessuna operazione registrata</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
